import store from "../redux/Store"
import {
    getAllVariants,
    storeEveryVariant
} from "../api/actions/actions";

export const fetchAllVariantsEvent = (force) => {

    let variants = store.getState().base.variants;

    if (force || !(Array.isArray(variants) && variants.length > 0)) {
        store.dispatch(getAllVariants())
            .unwrap()
            .then(result => {
                if (Array.isArray(result.content)) {
                    store.dispatch(storeEveryVariant(result.content));
                }
            })
            .catch(error => {
                console.error('fetchAllTagsEvent', error);
            });
    }
};

